"use client";

import { useInterimStateManager } from "@/state/globalStore";
import RerankSelection from "../workflows/rerank-selection/RerankSelection";
import WithGenericDialog from "@/shared/ui/gestures/WithGenericDialog";
import { PROFILE_SHAPING_LABELS } from "@/features/profile-shaping/config/actions";

export default function StudioDialogs() {
  const { interimState, setInterimState, resetInterimState } =
    useInterimStateManager();

  return (
    <WithGenericDialog
      title={PROFILE_SHAPING_LABELS.tailorToFocus}
      isOpen={interimState.rerank_dialog?.isOpen ?? false}
      onOpenChangeAction={(isOpen) => {
        setInterimState("rerank_dialog", { isOpen });
      }}
      onCloseAction={() => {
        resetInterimState("rerank_dialog");
      }}
      minContentHeight="420px"
    >
      <RerankSelection
        onDone={() => {
          resetInterimState("rerank_dialog");
        }}
      />
    </WithGenericDialog>
  );
}
